import {
  TrendingUp as TrendingUpIcon,
  FileText as FileTextIcon,
  Airplay as AirplayIcon,
  BookOpen as BookOpenIcon,
  Video as VideoIcon,
  Users as UsersIcon,
  UserCheck as UserCheckIcon,
  Sliders as SlidersIcon,
} from 'react-feather';

const superAdminNav = [
  {
    subheader: 'Learning',
    items: [
      {
        title: 'Words List',
        icon: BookOpenIcon,
        href: '/app/words-list',
        items: [
          {
            title: 'Manage Words',
            href: '/app/langauge-app/words-list',
          },
          {
            title: 'Add Word',
            href: '/app/langauge-app/create-word',
          },
        ],
      },
      {
        title: 'Sentence Construction',
        icon: SlidersIcon,
        href: '/app/sentence-construction',
        items: [
          {
            title: 'Manage Sessions',
            href: '/app/langauge-app/sentence-construction',
          },
          {
            title: 'Add Sessions',
            href: '/app/langauge-app/create-sentence-construction-session',
          },
        ],
      },
      {
        title: 'Conversation Practice',
        icon: VideoIcon,
        href: '/app/words-list',
        items: [
          {
            title: 'Characters',
            href: '/app/characters',
          },
          {
            title: 'Backgrounds',
            href: '/app/backgrounds',
          },
          {
            title: 'Conversation Practices',
            href: '/app/conversation-practices',
          },
        ],
      },
    ],
  },
  {
    subheader: 'Training Data Studio',
    items: [
      {
        title: 'Transcripts List',
        icon: BookOpenIcon,
        href: '/app/words-list',
        items: [
          {
            title: 'Manage Transcripts',
            href: '/app/langauge-app/transcript-list',
          },
          {
            title: 'Add Transcripts',
            href: '/app/langauge-app/create-transcript',
          },
        ],
      },
    ],
  },
];

export default superAdminNav;
